import React, { useContext, useState } from "react";

import { ModalContext } from "@/contexts/ModalsContext";
import { GlobalContext } from "@/contexts/GlobalContext";

import styles from "@/styles/components.module.scss";

const CookiesModal = () => {
    const { modalState: { consent }, dispatchModal } = useContext(ModalContext);
    const { dispatchGlobal } = useContext(GlobalContext);

    const [cookies, setCookies] = useState<{ ga?: boolean }>({ ga: true });
    const [reveal, setReveal] = useState<boolean>(false);

    if (!consent) return null;

    const handleToggleSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.currentTarget;
        
        setCookies({...cookies, [name]: checked});
    };

    const handleCloseModal = () => {
        localStorage.setItem("_consent", "confirmed");
        localStorage.setItem("_usc", JSON.stringify(cookies));
        dispatchModal({ type: "SET_CONSENT" });
        dispatchGlobal({ type: "SET_COOKIES", cookies: cookies });
    };

    const consentBody = (
        <React.Fragment>
            <div className={styles["cookies-card"]}>
                {reveal ? <div className={styles["cookies-card-text"]}>
                    <strong>Google Analytics</strong>
                    <p>These cookies help us improve our services and deliver a better experience</p>
                    <div className={styles["cookies-card-toggle"]}>
                        <input onChange={handleToggleSwitch} type="checkbox" checked={cookies.ga ? true : false} hidden name="ga" id="ga" />
                        <label htmlFor="ga">{cookies.ga ? "ON" : "OFF"}</label>
                        <div className={styles["cookies-footer"]}>
                            <button onClick={handleCloseModal} className={styles["cookies-close-btn"]}>CONFIRM</button>
                        </div>
                    </div>
                </div> :
                <div className={styles["cookies-overview"]}>
                    <button onClick={() => setReveal(true)} className={styles["cookies-reveal-btn"]}>Manage Cookies</button>
                    <button onClick={handleCloseModal} className={styles["cookies-close-btn"]}>Accept</button>
                </div>}
            </div>
        </React.Fragment>
    );

    return (
        <div className={styles["cookies-modal"]}>
            <div className={styles["cookies-body"]}>
                {!reveal && <div className={styles["cookies-header"]}>
                    <p>This site uses cookies to improve user experience.</p>
                </div>}
                {consentBody}
            </div>
        </div>
    );
};

export default CookiesModal;
